//  This should be on dropdown content view, prob want something simpler anyway

require('./style.less');

var Backbone = require('backbone'),
    $ = require('jquery'),
    DropDown = require('../../../../../../common/dropDown/dropDownWr.js'),
    Util = require('../../../../../../FV/util');


require('raphaelColorPicker');


module.exports = Backbone.View.extend({

    HEIGHT: 150,
    WIDTH: 150,

    initialize: function (options) {

        this.isOpen = 0;

        this.colorPicker =  null;

        this.parent = options.parent;

        //TODO: the note controller will not yet exist: (create prior to the toolbar)
        this.color = options.color;

        this.setElement( options.el );

        this.originalElTitleAttr = this.$el.attr('title');
        
        this.icn = this.$('i');

    },

    render: function() {

        var $cpDD = this.parent.$('#cp-dd')
            .css({
                width: this.WIDTH + 5,
                height: this.HEIGHT + 20 //(extra height for bottom slider)
            });

        this.updateOpenerDisplay( this.color );

        this.dropdown = new DropDown({ //! position (x, y must be set for the plugin to calc angles if put in container)
            parent: this,
            el: this.$el,
            ddOptions: {
                container: this.options.container,
                $content: $cpDD,
                hPos: 'right',
                onOpen: _.bind(function(hexColor) {

                    this.openCP(hexColor, $cpDD);

                }, this),

                onClose: _.bind( this.closeCP, this )
            }
        }).render();

    },

    /**
     * Now using its on onchange plugin
     * (starts open -- temp )
     *  note: <i> is dynamic, use the selector
     */
    openCP: function( hexColor, $cpDD ) {

        this.isOpen = 1;

        this.updateOpenerDisplay( this.color );
        
        var cpOffset = $cpDD.offset(),
            cp = this.colorPicker =
                Raphael.colorpicker( cpOffset.left, cpOffset.top, this.WIDTH, this.color, $cpDD[0] );

        /**
         * PATCH 712 -- ISSUE W/VERSION 2.1.4 -- prevent from circle disappearing
         * somewhere inside source set to fill opacity set to 1 on this node, which makes invisible
         * Note: not an issue with VML
         */

        $(cp.raphael.canvas)
            .find('circle').eq(0)
            .css('fill-opacity', 0);

        cp.onchange = _.bind( function(hexColor) {

            this.color = hexColor;

            this.parent.channel.trigger( 'colorPicker:setColor', hexColor );

            this.updateOpenerDisplay( this.color );


        }, this);

    },


    // For now must defer so other close triggers don't affect this one
    closeCP: function() {

        var self = this;

        setTimeout( function () {

            self.isOpen = 0;

            if (self.colorPicker) {  // The active dialog being closed (?)
                
                self.colorPicker.remove(); // Cleaning up correctly?
                self.colorPicker = null;  // there is a small memory leak ... no destroy implemented?
                
                self.updateOpenerDisplay();

            }

        }, 10);
    },

    updateOpenerDisplay: function( color ) {

        var color = color || this.color;

        this.$el.css({ background: color });

        this.icn.removeClass('arrowDown arrowUp'); // don't always need (eg when just change color )
        this.icn.removeAttr('style'); // border-bottom,  border top

        if ( this.isOpen ) {

            this.icn
                .addClass('arrowUp')
                .css('border-bottom-color', Util.getContrastYIQ(color) );

        } else {

            this.icn
                .addClass('arrowDown')
                .css( 'border-top-color', Util.getContrastYIQ(color) );

        }

    },

    /**
     * Toggle disabled and set a tooltip reason for why disabled.
     * disabledReason: if null, enable,
     * otherwise its a string containing the reason(s) to for the tooltip
     * to provide some level of clarity.
     */
    toggleDisabled: function( disabledReason ) {

        var disable = disabledReason !== null;

        this.$el.toggleClass( 'disabled', disable );

        var title = this.originalElTitleAttr;

        if ( disable ) {
            title += ' (disabled):\n' + disabledReason;
        }

        this.$el.attr( 'title', title );

    }
    
    //TODO: destroy

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/graphicNoteTB/colorSelector/colorSelector.js
 ** module id = 509
 ** module chunks = 0
 **/